"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.sendInvoices = void 0;
const handle_error_1 = require("../../../handle-error");
const sendInvoices = (client, logger) => async (payload) => {
    try {
        await client.post(`/v1/bff/appro/invoices/send`, payload);
    }
    catch (error) {
        (0, handle_error_1.handleError)(error, logger);
        throw error;
    }
};
exports.sendInvoices = sendInvoices;
